import type { ColDef } from 'ag-grid-community';

import { TextWithLinkCell } from '~/components/common';

import type { TypePostOrderExcelResponse } from '~/types/order.types';

/**
 * [출고주문관리] 주문 엑셀 일괄 등록 실패 모달 테이블
 */
const getOrderRegisterExcelUploadFailColumnDefs = () => {
  const columnDefs: ColDef<TypePostOrderExcelResponse['failResults'][number]>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'clientOrderCode',
      headerName: '판매처 주문번호',
      width: 160,
    },
    {
      field: 'failReason',
      headerName: '실패사유',
      minWidth: 500,
      flex: 1,
      wrapText: true,
      autoHeight: true,
      cellStyle: { padding: '9px 0' },
      cellRenderer: TextWithLinkCell,
    },
  ];

  return { columnDefs };
};

export default getOrderRegisterExcelUploadFailColumnDefs;
